<template>
  <!-- 承認待ち一覧画面 -->
  <CCard>
    <CCardHeader>
      <CRow>
        <CCol>
          <h2>承認待ち一覧</h2>
        </CCol>
      </CRow>
    </CCardHeader>
    <CCardBody>
      <p>あなたへ承認申請されている承認済み以外の提出物一覧です。</p>
      <p style="color: red" v-for="error in message" :key="error">
        {{ error }}
      </p>
      <div class="table-responsive">
        ※複数プロジェクトに所属している場合は代表プロジェクト１つを表示しています。
        <table class="table table-bordered">
          <thead>
            <tr>
              <th style="text-align: center" width="50">
                <input
                  type="checkbox"
                  v-model="selectAll"
                  @change="toggleSelectAll"
                />
              </th>
              <th scope="col" width="100px" nowrap>提出者名</th>
              <th scope="col" width="100px" nowrap>提出物</th>
              <th scope="col" width="100px" nowrap>年月</th>
              <th scope="col" width="100px" nowrap>プロジェクト名</th>
              <th scope="col" width="100px" nowrap>提出日</th>
              <th scope="col" nowrap>差戻し理由</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td style="text-align: center">
                <input type="checkbox" :value="item" v-model="selectedItems" />
              </td>
              <td nowrap>{{ item.submitter_name }}</td>
              <td nowrap>
                <router-link
                  :to="{
                    name: item.dynamic_route,
                    params: {
                      id: item.document_id,
                      user_id: item.user_id,
                      year: item.year,
                      month: item.month,
                      user_name: item.submitter_name,
                    },
                  }"
                  target="_blank"
                  >{{ item.document_name }}</router-link
                >
              </td>
              <td nowrap>{{ item.year_month }}</td>
              <td nowrap>{{ item.project_name }}</td>
              <td nowrap>{{ formatDate(item.submission_at) }}</td>
              <td width="450">
                <CTextarea 
                v-model="item.comment"
                rows="1"
                resize: vertical
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <CRow v-if="buttonMessage.length">
        <CCol>
          <p style="color: red" v-for="error in buttonMessage" :key="error">
            {{ error }}
          </p>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          Slack用追加コメント
          ※差戻し専用。承認については通知が煩雑になるためあえて通知させていません。
          <CTextarea rows="10" v-model="sns_message"></CTextarea>
        </CCol>
      </CRow>
      <br />
      <CRow class="justify-content-center">
        <CCol xs="auto">
          <div class="d-flex justify-content-center gap-3 flex-wrap text-nowrap">
            <button
              :loading="loading"
              v-if="!showButton"
              class="btn btn-danger"
              @click="rejection"
            >
              差戻し
            </button>
            <button
              :loading="loading"
              v-if="!showButton"
              class="btn btn-primary"
              @click="approval"
            >
              承認
            </button>
          </div>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from "axios";
import ConstList from "./../ConstList";
import SubmissionConst from "./ConstList";
export default {
  name: "SubmissionManagement",
  data() {
    return {
      items: [],
      message: [],
      buttonMessage: [], // ボタン押下イベントのメッセージ
      selectedItems: [], // 選択されたアイテムのIDを保持
      selectAll: false, // 全選択チェックボックスの状態
      showButton: false, // 申請ボタン・取消ボタンの表示非表示
      loading: false,
    };
  },
  // DBから各種情報を取得
  mounted: function () {
    axios
      .get(process.env.VUE_APP_API_ORIGIN + "/document/approval/list")
      .then((response) => {
        this.items = response.data;
        if (this.items.length === 0) {
          this.message.push(ConstList.EMPTY_REQUEST);
          // データがない場合はボタンを非表示に設定
          this.showButton = true;
        }
      })
      .catch((error) => {
        axios
        .get(
          `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
        )
        .then(() => {
          alert(ConstList.SYSTEM_ERROR);
        })
        .catch(() => {
          alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
        });
      });
  },
  methods: {
    // 承認
    approval: function () {
      // 1件も選択されていない場合
      if (this.selectedItems.length === 0) {
        this.buttonMessage.push(SubmissionConst.ERROR_MESSAGE_APPROVAL);
        this.messagehideDelay(3000);
        return;
      }
      const params = this.selectedItems.map((item) => ({
        id: item.id,
        document_type: item.document_type,
      }));
      this.$dialog
        .confirm(
          {
            title: "確認",
            body: "選択した提出物を承認してもよろしいですか？",
          },
          {
            okText: "はい",
            cancelText: "キャンセル",
          }
        )
        .then(() => {
          this.loading = true;
          axios
            .post(
              process.env.VUE_APP_API_ORIGIN + "/submission/approval",
              params,
              {
                headers: {
                  // content-type指定。@requestBodyでサーバ側にてバインドするため。
                  "Content-Type": "application/json",
                },
              }
            )
            .then(() => {
              alert(SubmissionConst.APPROVAL_MESSAGE);
              window.location.reload();
            })
            .catch((error) => {
              axios
              .get(
                `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
              )
              .then(() => {
                alert(ConstList.SYSTEM_ERROR);
              })
              .catch(() => {
                alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(function () {
          // キャンセル
        });
    },
    // 差戻
    rejection: function () {
      // 1件も選択されていない場合
      if (this.selectedItems.length === 0) {
        this.buttonMessage.push(SubmissionConst.ERROR_MESSAGE_REJECTION);
        this.messagehideDelay(3000);
        return;
      }
      // 選択した提出物のコメントが空だったら返す
      const selectComment = this.selectedItems.filter(
        (item) => item.comment === null
      );
      if (selectComment.length > 0) {
        this.buttonMessage.push(SubmissionConst.ERROR_MESSAGE_REJECT_REASON);
        this.messagehideDelay(3000);
        return;
      }
      const params = this.selectedItems.map((item) => ({
        id: item.id,
        user_id: item.user_id,
        approver_user_id:
          item.approver_user_id === null ? item.user_id : item.approver_user_id,
        comment: item.comment,
        document_type: item.document_type,
        sns_message: this.sns_message,
        year_month: item.year_month,
      }));
      this.$dialog
        .confirm(
          {
            title: "確認",
            body: "選択した提出物を差戻してもよろしいですか？",
          },
          {
            okText: "はい",
            cancelText: "キャンセル",
          }
        )
        .then(function () {
          axios
            .post(
              process.env.VUE_APP_API_ORIGIN + "/submission/rejection",
              params,
              {
                headers: {
                  // content-type指定。@requestBodyでサーバ側にてバインドするため。
                  "Content-Type": "application/json",
                },
              }
            )
            .then(() => {
              alert(SubmissionConst.REJECTION_MESSAGE);
              window.location.reload();
            })
            .catch((error) => {
              axios
              .get(
                `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
              )
              .then(() => {
                alert(ConstList.SYSTEM_ERROR);
              })
              .catch(() => {
                alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
              });
            });
        })
        .catch(function () {
          // キャンセル
        });
    },
    // ヘッダのチェックボックスを選択時
    toggleSelectAll() {
      if (this.selectAll) {
        // 全選択チェックボックスがチェックされた場合、全てのアイテムにチェック
        this.selectedItems = this.items.map((item) => item);
      } else {
        this.selectedItems = [];
      }
    },
    // メッセージの表示時間設定
    messagehideDelay: function (delay) {
      setTimeout(() => {
        this.buttonMessage = [];
      }, delay);
    },
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },
  watch: {
    selectedItems: function () {
      // 選択されたアイテムの数がテーブルのアイテム数と一致しない場合、全選択チェックボックスをfalseにする(外す)
      this.selectAll = this.selectedItems.length === this.items.length;
    },
  },
};
</script>

<style scoped>
td {
  word-break: break-all;
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}

.form-group {
  margin-bottom: 0rem;
}
</style>
